'use strict';

function getSelectionRaw () {
  return global.getSelection();
}

module.exports = getSelectionRaw;
